/**
 * Collects user's current window width and height when executed.
 * @returns
 */
export var getScreenSize = function getScreenSize() {
  return {
    height: screen.height,
    width: screen.width
  };
};